import {
  hubSupportTicketAttachmentKind,
  openHubSupportTicketAttachment,
  type HubSupportTicketAttachmentView,
} from "@/lib/hubSupportTicketAttachments";

export function HubSupportTicketAttachmentList({
  attachments,
  thumbnailClassName = "h-20 w-full object-cover",
}: {
  attachments: HubSupportTicketAttachmentView[];
  thumbnailClassName?: string;
}): JSX.Element | null {
  if (attachments.length === 0) {
    return null;
  }
  return (
    <ul className="flex flex-wrap gap-3">
      {attachments.map((attachment) => {
        const kind = attachment.kind ?? hubSupportTicketAttachmentKind(attachment.mimeType);
        const fileName = attachment.fileName?.trim() || "attachment";
        if (kind === "image") {
          return (
            <li key={attachment.id} className="w-28 shrink-0">
              <button
                type="button"
                title="Open full image in new tab"
                className="block w-full cursor-pointer overflow-hidden rounded border border-slate-200 p-0 text-left ring-offset-2 hover:border-slate-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
                onClick={() => openHubSupportTicketAttachment(attachment.dataUrl, fileName)}
              >
                <img src={attachment.dataUrl} alt="" className={thumbnailClassName} />
              </button>
            </li>
          );
        }
        return (
          <li key={attachment.id} className="max-w-[12rem] shrink-0">
            <button
              type="button"
              className="w-full rounded border border-slate-200 bg-white px-2 py-2 text-left text-xs font-medium text-slate-700 hover:border-slate-300 hover:bg-slate-50"
              onClick={() => openHubSupportTicketAttachment(attachment.dataUrl, fileName)}
            >
              {fileName}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
